<template>
    <div class="col-sm-4" v-if="can('tariffs.index','privileges.index','baggage.index','services.index')">
        <div class="card">
            <div class="card-header">
                <h1 class="card-title">{{i18n("Pricing")}}</h1>
            </div>
            <div class="card-body">
                <ul class="list-unstyled grid-list">
                    <router-link to="/tariffs" tag="li" v-if="can('tariffs.index')">
                        <a href="#" title="">{{i18n('Tariffs')}}</a>
                    </router-link>
                    <router-link to="/privileges" tag="li" v-if="can('privileges.index')">
                        <a href="#" title="">{{i18n("Privileges")}}</a>
                    </router-link>
                    <router-link to="/baggage" tag="li" v-if="can('baggage.index')">
                        <a href="#" title="">{{i18n("Baggage")}}</a>
                    </router-link>
                    <router-link to="/services" tag="li" v-if="can('services.index')">
                        <a href="#" title="">{{i18n("Services")}}</a>
                    </router-link>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PricingCard"
    }
</script>

<style scoped>

</style>
